export class RafEtiket{
    
    Id:number;
    StokKartiID:number;
    StokAdi:string;
    
}


// WEBPACK FOOTER //
// ./src/models/RafEtiket.ts